import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { previewCss, primitivesCss, profileEditorCss, scoreCss, themeCss } from '@ai-job-fit/ui'
import { App } from './App'
import { applyStoredTheme } from './lib/theme'
import { installerCaptureErreurs } from './lib/mesure'
import './app.css'

// Le socle de tokens et les styles de la modale d'aperçu viennent du paquet
// partagé, comme les composants eux-mêmes. L'extension les injecte dans son
// shadow DOM ; ici une simple balise <style> suffit.
//
// La console laisse choisir le thème (attribut `data-theme` sur <html>), d'où
// les deux sélecteurs de sombre : l'automatique doit épargner le clair forcé,
// sinon `prefers-color-scheme` reprendrait la main sur le choix explicite.
const style = document.createElement('style')
style.textContent =
  themeCss({
    selector: ':root',
    autoDarkSelector: ':root:not([data-theme="light"])',
    forcedDarkSelector: ':root[data-theme="dark"]',
  }) +
  primitivesCss +
  previewCss +
  // L'anneau de score, le panneau et le comparateur : le widget les dessinait
  // dans son shadow-root, la console avait sa propre pastille rectangulaire.
  // Une seule feuille désormais.
  scoreCss +
  // L'éditeur du CV maître, le même que dans les options de l'extension.
  profileEditorCss
document.head.appendChild(style)

// Les erreurs JavaScript de Radar (issue #193) ; rien ne part en console ni en
// administration, `activerMesure` n'y est jamais allumé.
installerCaptureErreurs()

// Avant le premier rendu, sinon l'écran s'affiche une fraction de seconde dans
// le thème du système avant de basculer sur le thème choisi.
applyStoredTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
